module.exports = require("@mui/material/CircularProgress");